import { useState } from 'react'

interface UseThingsToConsiderType {
  showThingsToConsiderCard: boolean
  handleThingsToConsider: () => void
}
export const useThingsToConsider = (): UseThingsToConsiderType => {
  const [showThingsToConsiderCard, setShowThingsToConsiderCard] = useState<boolean>(false)

  const handleThingsToConsider = (): void => {
    setShowThingsToConsiderCard(show => !show)
  }

  return { showThingsToConsiderCard, handleThingsToConsider }
}
